<template>
  <div>
    <Dashboard></Dashboard>
    <EventDetailModal></EventDetailModal>
    <EventModal></EventModal>
    <ModalChangeOrderDetail></ModalChangeOrderDetail>
    <EventStaffingDetail></EventStaffingDetail>
    <ManageEmailModal></ManageEmailModal>
    <EmailHistoriesManagement></EmailHistoriesManagement>
  </div>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex';
  import Dashboard from '../../../components/eventManagement/main/Dashboard.vue';
  import EventDetailModal from '../../../components/modal/event/EventDetailModal';
  import ModalChangeOrderDetail from '../../../components/modal/ModalChangeOrderDetail';
  import EventModal from '../../../components/modal/Modal';
  import EventStaffingDetail from '../../staffing/EventStaffingDetail';
  import ManageEmailModal from '../../../views/email/ManageEmail';
  import EmailHistoriesManagement from '../../../views/email/EmailHistoriesManagement';

  import 'vue-awesome/icons/file-excel-o';
  import 'vue-awesome/icons/question-circle-o';
  import 'vue-awesome/icons/sort-down';
  import 'vue-awesome/icons/users';

  export default {
    name: 'c-dashboard-client-view',
    components: {
      Dashboard,
      EventDetailModal,
      ModalChangeOrderDetail,
      EventModal,
      EventStaffingDetail,
      ManageEmailModal,
      EmailHistoriesManagement
    },
    props: {},
    data () {
      return {};
    },
    computed: {
      ...mapGetters({})
    },
    methods: {
      ...mapActions({})
    },
    beforeMount () {
    },
    mounted () {
    },
    watch: {}
  };
</script>

<style lang="less">
  @import '~@/styles/variables.less';
</style>




// WEBPACK FOOTER //
// Dashboard.vue?36d09078